// removed by extract-text-webpack-plugin
module.exports = {"content":"content__1-3Qh","title":"title__29dvq","props":"props__1miRZ","label":"label__3tsgH","value":"value__22rQz","datatable":"datatable__3Kqdt","field-help":"field-help__3Rpe_","refresh":"refresh__1RwlD","unconection-websocket":"unconection-websocket__3EmgQ","submit":"submit__14h0p"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Application/coms/ApplicationDetail/coms/APIView/coms/AppDebug/coms/DetailView/styles.scss
// module id = 2169
// module chunks = 1